<div class="row">
  <div class="col-12">
    <div class="input-group">
      <input type="text" 
             #input 
             class="form-control" 
             placeholder="{{placeHolder || 'Pretraga'}}"
             (keyup)="onSearch(input.value, $event)"
             [disabled]="isDisabled">

      <span class="input-group-append">
        <button class="btn btn-secondary"
                (click)="onResetSearch('')"
                *ngIf="input.value.length > 0"
                type="button">
          <i class="fa fa-times"></i></button>
      </span>
    </div>
  </div>
</div>
